import { parseRichText } from "@/lib/richText";

// Renders free text (currently just the public event description) with
// clickable links, when the organiser wrote [label](url) or just pasted a
// bare http(s)/mailto URL inline. Never uses dangerouslySetInnerHTML -- only
// the links parseRichText itself recognised (and only http(s)/mailto ones)
// are ever rendered as a real <a>; everything else stays plain text, exactly
// as typed. The wrapping element's own `white-space: pre-line` (already used
// by every caller) still preserves line breaks, since these are ordinary
// text nodes.
export default function RichText({ text }) {
  const tokens = parseRichText(text);
  return tokens.map((token, i) =>
    token.type === "link" ? (
      <a
        key={i}
        href={token.url}
        target="_blank"
        rel="noopener noreferrer"
        className="text-svj-cyan underline hover:no-underline"
      >
        {token.label}
      </a>
    ) : (
      <span key={i}>{token.value}</span>
    )
  );
}
